import merge from 'deepmerge'
import CalendarMessages from './messages'
import CalendarPermissionMessages from './permissions/CalendarPermissionMessages'

const messages = merge.all([
    CalendarMessages,
    CalendarPermissionMessages
])

export default messages
